// extracted by mini-css-extract-plugin
module.exports = {"image1":"Diagnosis_image1__2bxWp","image2":"Diagnosis_image2__1-AAr","parent":"Diagnosis_parent__2T1KF"};